import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSnapshot } from "valtio";
import { authStore } from "../../stores/authStore";

/**
 * Redirects to dashboard if user is already authenticated
 * Used for login/signup pages to prevent access when already logged in
 */
export function RedirectIfAuthenticated({ children }) {
  const { isAuthenticated, user } = useSnapshot(authStore);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated) return;
    // Get the intended destination from location state or default to dashboard
    const from = location.state?.from?.pathname || "/dashboard";
    navigate(from, { replace: true });
  }, [isAuthenticated, navigate, location.state]);

  if (!isAuthenticated) {
    return children;
  }
  // Show a loading state while redirecting
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin text-blue-500 rounded-full h-12 w-12 border-t-2 border-b-2 border-[var(--primary-font)]"> </div>
    </div>
  );
}
